<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="480px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                    <el-form-item prop="bindDeptIdstr" label="管理机构">
                         <el-cascader style=" width:250px;"
                            :options="depts"
                            v-model="form.bindDeptIdstr"
                            :props="props"
                            collapse-tags
                            clearable></el-cascader>
                    </el-form-item>
                    
                    <el-form-item prop="dormitoryType" label="宿舍类型">
                        <el-select v-model="form.dormitoryType" clearable placeholder="请选择" style=" width:250px;">
                            <el-option
                                v-for="item in dormitoryTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item prop="dormitoryController" label="宿舍生管">
                        <el-button @click="findUser()">{{form.dormitoryControllerLabel}}</el-button>
                    </el-form-item>

                    <el-form-item   prop="" label="通知设置">
                        <div border style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);width:250px;">
                            <el-checkbox v-for="noticeSet in noticeSetArr" :key="noticeSet.value"  v-model="form.noticeSet" :label="noticeSet.value" border size="medium" style="margin:5px;">
                                {{noticeSet.label}}
                            </el-checkbox>
                        </div>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import userTransfer from '../../sys/user/UserTransfer.vue';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                isAuto:false,
                transferVisible:false,
                props: { multiple: true,  checkStrictly: true },
                form:{
                    id:"",
                    deptId:"",
                    bindDeptIdstr:"",
                    dormitoryType:"",
                    dormitoryController:[],
                    dormitoryControllerLabel:"请选择",
                    noticeSet:[]
                },
                rules: {
                    bindDeptIdstr: [
                        { required: true, message: '请选择绑定机构', trigger: 'blur' }
                    ],
                    dormitoryType: [
                        { required: true, message: '请选择宿舍类型', trigger: 'blur' }
                    ]
                },
                noticeSetArr:[
                    {
                        value:'notReturn_key',
                        label:'已归'
                    },
                    {
                        value:'lateReturn_key',
                        label:'晚归'
                    },
                    {
                        value:'longTimeLateReturn_key',
                        label:'长时晚归'
                    }
                ],
                depts:[],
                dormitoryTypes:[
                    {
                        value:1,
                        label:'男生宿舍'
                    },
                    {
                        value:2,
                        label:'女生宿舍'
                    }
                ]
            }
        },
        created:function () {
        },
        components: {
            userTransfer
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(type,data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                // 初始值
                this.form.id=data.id;
                this.form.bindDeptIdstr=(data.bindDeptIdstr== null?"":data.bindDeptIdstr);
                this.form.dormitoryType=data.dormitoryType;
                this.form.dormitoryController=(data.dormitoryController==null?"":data.dormitoryController.split(','));
                if(this.form.dormitoryController == '' || this.form.dormitoryController == null){
                    this.form.dormitoryControllerLabel="请选择";
                }else{
                    this.form.dormitoryControllerLabel=this.form.dormitoryController.length+"人";
                }
                this.form.deptId=data.deptId;
                this.getDeptCascader();
                // 通知设置
                if(this.$util.isNotEmpty(data.noticeSet)){
                    this.form.noticeSet=data.noticeSet.split(',');
                }else{
                    this.form.noticeSet=[];
                }
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            //部门
            getDeptCascader(){
                let url  = this.getDeptCascaderUrl;
                let data = {
                    'deptId':this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                      this.depts = res.data.selects;
                      this.form.bindDeptIdstr = this.getName(this.form.bindDeptIdstr, this.depts);
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 绑定人员
            findUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.form.dormitoryController.length > 0){
                        this.$refs['userTransfer'].init(2,this.form.dormitoryController,2,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init(2,null,2,this.form.deptId);
                    }
                })
            },
            setUser(keyArr){
                if(keyArr.length == 0){
                    this.form.dormitoryController=keyArr;
                    this.form.dormitoryControllerLabel="请选择";
                }else{
                  this.form.dormitoryController=keyArr;
                  this.form.dormitoryControllerLabel=keyArr.length+"人";
                }
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        // 管理机构
                        let bindDeptIdstr=this.filterCascader(this.form.bindDeptIdstr);

                        let url = this.boarderWechatNoticeUpdateUrl;
                        let data = {
                            id:this.form.id,
                            bindDeptIdstr:bindDeptIdstr,
                            dormitoryType:this.form.dormitoryType,
                            dormitoryController:this.form.dormitoryController.join(","),
                            noticeSet:this.form.noticeSet.join(),
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                                this.visible=false;
                                this.$parent.getData();
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
                });
            },
            filterCascader(data){
                // 获取任意选项最后值
                let arrVal = new Array();
                for(var i=0; i<data.length;i++){
                    arrVal.push(data[i][data[i].length-1]);
                }
               return arrVal.join();
            },
            getName(setVal,data){
                // 角色、部门递归获取层级名称
                if(this.$util.isNotEmpty(data)){

                   let valArr = setVal.split(",");
                   var arr = new Array();
                   for(var i = 0;i < valArr.length;i++){
                       var tempArr = new Array();
                       this.recursionCascader(valArr[i], data, tempArr, data);
                       arr.push(tempArr.reverse());
                   }
                   // console.log("获取值"+JSON.stringify(arr))
                   return arr;
                }
            },
            recursionCascader(val, cdata, tempArr, data){
                if(val == 0){
                    return;
                }
                // 递归获取值
                for(var i=0; i<cdata.length;i++){
                   if(cdata[i].value == val){
                       tempArr.push(val);
                       this.recursionCascader(cdata[i].parentId, data, tempArr, data);
                   }
                   if(cdata[i].children && cdata[i].children.length) {
                       this.recursionCascader(val, cdata[i].children, tempArr, data);
                   }
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/hostel/notice/Update.vue